<template>
    <main class="authorization-content authorization-content_bg"> 
      <div class="autorization">
        <div class="autorization__body popup box bg-white">
          <form id="autorization-form" name="autorization-form" method="post">
            <div class="popup__header">
              <div class="popup__title section__title section__title_style3">{{ $t("welcome") }}</div>
              <div class="popup__logo svg-icon" aria-hidden="true">
                <svg role="img" width="63" height="24" aria-hidden="true">
                  <use xlink:href="#svg-logo-mobile"></use>
                </svg>
              </div>
            </div>
            <div class="popup__body">
              {{$t(message)}}
            </div>
            <div class="popup__footer">
              <div class="row align-items-center justify-content-center form_footer">
                <router-link to="/login" class="btn btn_default btn_white btn_message" type="button">{{ $t("go") }}</router-link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
</template>
<script>
import {mapActions} from 'vuex'
export default {
    data() {
        return {
            message: ''
        }
    },
    methods: {
        ...mapActions({
          auth: 'authorization/loginVerification',
        }),
        verification(token){
          if(token){
            this.auth(token).then((resp) => {
              if(resp === 200){
                this.message = 'successReg'
              }if(resp === 401){
                this.message = 'errorReg'
              }
            })
          }
        }
    },
    mounted() {
        this.verification(location.search.substr(7))
    }
}
</script>
<style scoped>

</style>